// extracted by mini-css-extract-plugin
export default {"payment":"Nz","title_row":"Oz","border_bottom":"Pz","promo_wrapper":"Qz","payment_wrapper":"Rz","label":"Sz","card_row":"Tz","cardcontain":"Uz","card_input":"Vz","card_error":"Wz","card_label":"Xz","lock":"Yz","same_address":"Zz","place_order_button":"aA","buttonwrap":"bA","hide_form":"cA","paypal_buttons":"eA","review_button":"fA","alt_payment":"gA"};
    if(module.hot) {
      // 1715091678892
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  